module.exports = __webpack_public_path__ + "img/account-icon-active.b2682612.svg";